import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "apps-page"
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-body pt-0"
  }, [_vm.showCheckoutReturnMessage ? _c('b-alert', {
    staticClass: "mb-5",
    attrs: {
      "show": "",
      "variant": _vm.checkoutReturnVariant
    }
  }, [_vm._v(" " + _vm._s(_vm.checkoutReturnMessage) + " ")]) : _vm._e(), _c('div', {
    staticClass: "apps-toolbar"
  }, [_c('div', {
    staticClass: "filter-tabs"
  }, _vm._l(_vm.availableFilters, function (filter) {
    return _c('button', {
      key: filter.value,
      staticClass: "btn btn-sm",
      class: _vm.selectedFilter === filter.value ? 'btn-primary' : 'btn-light-primary',
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          _vm.selectedFilter = filter.value;
        }
      }
    }, [_vm._v(" " + _vm._s(filter.label) + " ")]);
  }), 0), _c('div', {
    staticClass: "search-wrapper"
  }, [_c('MagnifyIcon', {
    staticClass: "search-icon",
    attrs: {
      "size": 19
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.search,
      expression: "search",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Buscar app"
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.search = $event.target.value.trim();
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })], 1)]), _vm.isLoading ? _c('div', {
    staticClass: "apps-loading"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary",
      "label": "Carregando..."
    }
  })], 1) : _vm.filteredApps.length === 0 ? _c('div', {
    staticClass: "apps-empty"
  }, [_c('AppsIcon', {
    attrs: {
      "size": 36
    }
  }), _c('strong', [_vm._v("Nenhum app encontrado")]), _c('span', [_vm._v("Ajuste os filtros ou a busca para visualizar outros apps.")])], 1) : _c('div', {
    staticClass: "apps-grid"
  }, _vm._l(_vm.filteredApps, function (app) {
    return _c('div', {
      key: _vm.appKey(app),
      staticClass: "app-card",
      class: _vm.appCardClass(app)
    }, [_c('div', {
      staticClass: "app-card-header"
    }, [_c('div', {
      staticClass: "app-card-icon-type"
    }, [_c('div', {
      staticClass: "app-icon",
      class: _vm.appTypeClass(app)
    }, [_vm.normalizedType(app) === 'plugin' ? _c('PuzzleIcon', {
      attrs: {
        "size": 24
      }
    }) : _c('AppsIcon', {
      attrs: {
        "size": 24
      }
    })], 1), _c('div', {
      staticClass: "app-card-meta"
    }, [_c('span', {
      staticClass: "app-type"
    }, [_vm._v(_vm._s(_vm.appTypeLabel(app)))])])]), _c('span', {
      staticClass: "status-badge",
      class: [_vm.statusClass(app.status), {
        'badge-coming-soon': _vm.isComingSoonStatus(app.status)
      }],
      attrs: {
        "title": _vm.statusTooltip(app.status)
      }
    }, [_vm._v(" " + _vm._s(_vm.statusLabel(app.status)) + " ")])]), _c('h3', {
      staticClass: "app-card-title"
    }, [_vm._v(_vm._s(app.name))]), _c('p', {
      staticClass: "app-description app-card-description"
    }, [_vm._v(_vm._s(_vm.appDescription(app)))]), _vm.normalizedRecommendedFor(app).length ? _c('div', {
      staticClass: "app-recommended"
    }, [_c('strong', [_vm._v("Recomendado para:")]), _c('span', [_vm._v(_vm._s(_vm.normalizedRecommendedFor(app).join(" • ")))])]) : _vm._e(), _vm.normalizedTags(app).length ? _c('div', {
      staticClass: "app-tags"
    }, _vm._l(_vm.normalizedTags(app), function (tag) {
      return _c('span', {
        key: "".concat(_vm.appKey(app), "-").concat(tag),
        staticClass: "app-tag"
      }, [_vm._v(" " + _vm._s(tag) + " ")]);
    }), 0) : _vm._e(), _c('div', {
      staticClass: "benefits"
    }, [_c('strong', [_vm._v("Benefícios:")]), _c('ul', _vm._l(_vm.normalizedBenefits(app), function (benefit) {
      return _c('li', {
        key: benefit
      }, [_vm._v(" " + _vm._s(benefit) + " ")]);
    }), 0)]), _c('div', {
      staticClass: "app-card-footer"
    }, [_c('div', {
      staticClass: "app-price",
      class: {
        'app-price-per-quantity': _vm.isPerQuantity(app)
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.monthlyPriceLabel(app)))]), _vm.isPerQuantity(app) ? _c('small', [_vm._v(" /mês por " + _vm._s(_vm.unitPriceLabel(app)) + " ")]) : _c('small', [_vm._v("/mês")])]), _vm.showQuantitySelector(app) ? _c('div', {
      staticClass: "quantity-section"
    }, [_c('strong', [_vm._v(_vm._s(_vm.quantitySelectorLabel(app)) + ":")]), _c('div', {
      staticClass: "quantity-controls"
    }, [_c('button', {
      staticClass: "btn btn-light-primary btn-sm",
      attrs: {
        "type": "button",
        "disabled": _vm.selectedQuantity(app) <= _vm.minQuantity(app)
      },
      on: {
        "click": function click($event) {
          return _vm.decreaseQuantity(app);
        }
      }
    }, [_vm._v(" - ")]), _c('span', {
      staticClass: "quantity-value"
    }, [_vm._v(_vm._s(_vm.selectedQuantity(app)))]), _c('button', {
      staticClass: "btn btn-light-primary btn-sm",
      attrs: {
        "type": "button",
        "disabled": _vm.selectedQuantity(app) >= _vm.maxQuantity(app)
      },
      on: {
        "click": function click($event) {
          return _vm.increaseQuantity(app);
        }
      }
    }, [_vm._v(" + ")])]), _c('span', {
      staticClass: "quantity-total"
    }, [_vm._v(" " + _vm._s(_vm.quantityTotalLabel(app)) + ": "), _c('strong', [_vm._v(_vm._s(_vm.totalMonthlyPriceLabel(app)) + "/mês")])])]) : _vm._e(), _vm.showInstalledUsage(app) ? _c('div', {
      staticClass: "installed-usage"
    }, [_c('strong', [_vm._v(" " + _vm._s(_vm.installedQuantity(app)) + " " + _vm._s(_vm.quantityLabelPlural(app, _vm.installedQuantity(app))) + " contratados ")]), _c('span', [_vm._v(" " + _vm._s(_vm.usedQuantity(app)) + " " + _vm._s(_vm.quantityLabelPlural(app, _vm.usedQuantity(app))) + " em uso ")]), _c('span', [_vm._v(" " + _vm._s(_vm.availableInstalledQuantity(app)) + " disponível " + _vm._s(_vm.availableInstalledQuantity(app) === 1 ? '' : 's') + " ")])]) : _vm._e(), _vm.showActionButton(app) ? _c('button', {
      staticClass: "btn font-weight-bold",
      class: _vm.actionButtonClass(app),
      attrs: {
        "type": "button",
        "disabled": _vm.isActionDisabled(app) || _vm.loadingCheckoutCode === _vm.appCode(app)
      },
      on: {
        "click": function click($event) {
          return _vm.handleAction(app);
        }
      }
    }, [_vm.loadingCheckoutCode === _vm.appCode(app) ? _c('b-spinner', {
      staticClass: "mr-2",
      attrs: {
        "small": ""
      }
    }) : _c(_vm.actionIcon(app), {
      tag: "component",
      staticClass: "mr-2",
      attrs: {
        "size": 18
      }
    }), _vm._v(" " + _vm._s(_vm.actionLabel(app)) + " ")], 1) : _vm._e()])]);
  }), 0)], 1)]), _c('b-modal', {
    ref: "contractAppModal",
    attrs: {
      "id": "contract-app-modal",
      "centered": "",
      "hide-footer": "",
      "title": _vm.contractModalTitle()
    }
  }, [_vm.selectedApp ? _c('p', {
    staticClass: "mb-3"
  }, [_vm._v(" " + _vm._s(_vm.contractModalText()) + " ")]) : _vm._e(), _vm.selectedApp && _vm.selectedCheckoutMode === 'add_quantity' ? _c('div', {
    staticClass: "checkout-summary mb-4"
  }, [_c('span', [_vm._v("Valor adicional:")]), _c('strong', [_vm._v(" " + _vm._s(_vm.selectedAppQuantity) + " x " + _vm._s(_vm.monthlyPriceLabel(_vm.selectedApp)) + " = " + _vm._s(_vm.contractModalTotalLabel()) + "/mês ")])]) : _vm._e(), _c('p', {
    staticClass: "text-muted mb-0"
  }, [_vm._v(" Você será redirecionado para o checkout seguro do Asaas. Após a confirmação do pagamento, " + _vm._s(_vm.selectedCheckoutMode === 'add_quantity' ? 'a quantidade contratada será atualizada automaticamente.' : 'o app será liberado automaticamente para sua empresa.') + " ")]), _c('div', {
    staticClass: "d-flex justify-content-end mt-7"
  }, [_c('button', {
    staticClass: "btn btn-light-primary font-weight-bold mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideContractModal
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button",
      "disabled": _vm.isConfirmingCheckout
    },
    on: {
      "click": _vm.confirmCheckout
    }
  }, [_vm.isConfirmingCheckout ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _c('CreditCardIcon', {
    staticClass: "mr-2",
    attrs: {
      "size": 18
    }
  }), _vm._v(" Ir para pagamento ")], 1)])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header border-0 py-5"
  }, [_c('div', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v("Apps")]), _c('span', {
    staticClass: "text-muted mt-2 font-weight-bold font-size-sm"
  }, [_vm._v(" Adicione módulos e extensões para personalizar o Sistema Nuts conforme a necessidade da sua empresa. ")])])]);
}];
export { render, staticRenderFns };